import './App.css';
import React, {useEffect, useState} from "react";
import {Breadcrumb, Button, ConfigProvider, Layout, Menu} from "antd";
import {ArrowLeftOutlined, HomeOutlined, LaptopOutlined, LogoutOutlined, NotificationOutlined} from "@ant-design/icons";
import {createHashRouter, HashRouter, Route, RouterProvider} from "react-router-dom";
import Home from "./Home";
import Qygl from "./Qygl";
import Sbcl from "./Sbcl";
import Sbnr from "./Sbnr";
import Yfhd from "./Yfhd";
import Gxcp from "./Gxcp";
import Zccqhz from "./Zccqhz";
import Kffymx from "./Kffymx";
import Hyzdmx from "./Hyzdmx";
import Rlzy from "./Rlzy";
import {LogtoProvider, useHandleSignInCallback, useLogto} from "@logto/react";
import {Callback} from "./component/Callback";
import {ApolloClient, ApolloProvider, HttpLink, InMemoryCache, split} from "@apollo/client";
import {APIURL, SERVER} from "./config";
import {GraphQLWsLink} from "@apollo/client/link/subscriptions";
import {createClient} from "graphql-ws";
import {getMainDefinition} from "@apollo/client/utilities";
import {useLocalStorage} from "./Utils";
import {App as AntdApp} from "antd";

const {SubMenu} = Menu;
const {Header, Content, Sider} = Layout;

const router=(logto) => createHashRouter([
    {
        path: "/",
        element: <Home logto={logto}/>,
        // loader: rootLoader,
        // children: [
        //     {
        //         path: "team",
        //         element: <Team />,
        //         loader: teamLoader,
        //     },
        // ],
    },
    {
        path: "/qygl",
        element: <Qygl/>,
    },
    {
        path: "/sbcl",
        element: <Sbcl logto={logto}/>,
    },
    {
        path: "/sbnr",
        element: <Sbnr/>,
    },
    {
        path: "/yfhd",
        element: <Yfhd/>,
    },
    {
        path: "/gxcp",
        element: <Gxcp/>,
    },
    {
        path: "/zccqhz",
        element: <Zccqhz/>,
    },
    {
        path: "/kffymx",
        element: <Kffymx/>,
    },
    {
        path: "/hyzdmx",
        element: <Hyzdmx/>,
    },
    {
        path: "/rlzy",
        element: <Rlzy/>,
    },
]);

export default function App() {
    const [nowHash, setNowHash] = useLocalStorage('nowHash', window.location.hash)
    const [token, setToken] = useLocalStorage('accessToken', '')
    const [needRefreshToken, setNeedRefreshToken] = useState(false)
    const [menuSelect, setMenuSelect] = useState(window.location.hash)
    const [historyLength, setHistoryLength] = useState(window.history.length)
    const logto = useLogto()
    const code = (new URL(document.location)).searchParams.get('code')
    const {message, modal, notification} = AntdApp.useApp();

    Promise.prototype.fankui = function () {
        const key = Math.random()
        const msg = message.loading({content: '正在处理', key}, 0)
        const p =
            this.then(value => {
                if (value.data) {
                    return message.success({content: '已完成', key})
                } else {
                    return message.error({content: '发生错误', key})
                }
            }).catch(reason => {
                return message.error({content: '发生错误', key})
            })
        msg.then(p)
        return this
    }

    window.onhashchange = event => {
        setMenuSelect(window.location.hash)
        setHistoryLength(window.history.length)
    }
    useEffect(() => {
        if (!code) {
            if (!logto.isLoading) {
                if (needRefreshToken) {
                    const tryLogin = async () => {
                        setNeedRefreshToken(false)
                        if (logto.isAuthenticated) {
                            logto.getAccessToken('https://gqrd.api').then(accessToken => {
                                // localStorage.setItem("accessToken", accessToken);
                                setToken(accessToken)
                            }).catch((error, a) => {
                                console.log(error, a)
                            });
                        } else {
                            if (window.location.hash) {
                                setNowHash(window.location.hash)
                            }
                            logto.signIn(window.location.origin)
                        }
                    }
                    tryLogin()
                }
            }
        }
    }, [logto.isLoading, logto.isAuthenticated, needRefreshToken])
// useEffect(()=>{
//     setInterval( () => {
//         setNeedRefreshToken(true)
//     },10000)
// },[])
    if (code) {
        return <Callback nowHash={nowHash}/>
    }
    const httpLink = new HttpLink({
        uri: APIURL + '/v1/graphql',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Expected-Role': 'user'
        }
    });
    const getHeaders = () => {
        const headers = {}
        // const token = window.localStorage.getItem("accessToken")
        if (token) {
            headers["Authorization"] = `Bearer ${token}`
            headers['Expected-Role'] = 'user'
        }
        return headers
    }

    const wsLink = new GraphQLWsLink(createClient({
        url: `wss://${SERVER}/v1/graphql`,
        reconnect: true,
        lazy: true,
        timeout: 30000,
        inactivityTimeout: 30000,
        connectionParams: () => {
            return {headers: getHeaders()}
        },
        // connectionParams: {
        //     authToken: `Bearer ${localStorage.getItem("accessToken")}`,
        //     'Authorization': `Bearer ${localStorage.getItem("accessToken")}`,
        //     'Expected-Role': 'admin'
        // },
    }));

    wsLink.client.on("message", (message) => {
        console.log(message)
    })

    wsLink.client.on("error", (error, options) => {
        console.log(error, options)
        if (error.message === "Invalid message 'type' property \"connection_error\"") {
            if (!logto.isLoading) {
                if (window.location.hash) {
                    setNowHash(window.location.hash)
                }
                localStorage.removeItem('accessToken');
                setNeedRefreshToken(true)
            }
        }
    })

// The split function takes three parameters:
//
// * A function that's called for each operation to execute
// * The Link to use for an operation if the function returns a "truthy" value
// * The Link to use for an operation if the function returns a "falsy" value
    const splitLink = split(
        ({query}) => {
            const definition = getMainDefinition(query);
            return (
                definition.kind === 'OperationDefinition' &&
                definition.operation === 'subscription'
            );
        },
        wsLink,
        httpLink,
    );


    const client = new ApolloClient({
        link: splitLink,
        cache: new InMemoryCache()
    });


    return (<ApolloProvider client={client}>
            <Layout>
                <Header className="header">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}>
                        <div className="logo">
                            <img src={'logo.png'}
                                 style={{width: '155px', paddingTop: '8px'}}/>
                        </div>
                        <div>
                            <Button ghost onClick={() => {
                                setToken('')
                                setNeedRefreshToken(false)
                                logto.signOut()
                            }}><LogoutOutlined/> 注销</Button>
                        </div>
                    </div>
                </Header>
                <Layout>
                    <Sider width={200} className="site-layout-background">
                        <Menu
                            mode="inline"
                            selectedKeys={[(menuSelect.split("?")[0] || menuSelect).slice(1)]}
                            defaultOpenKeys={['bbgl', 'sbcl']}
                            style={{height: '100%', borderRight: 0}}
                            onSelect={(i) => {
                                window.location.hash = i.key
                            }}
                        >
                            <Menu.Item key="" icon={<HomeOutlined/>}>首页</Menu.Item>
                            {/*<SubMenu key="bbgl" icon={<LaptopOutlined/>} title="企业管理">*/}
                            {/*    <Menu.Item key="/qygl">企业管理</Menu.Item>*/}
                            {/*    /!*<Menu.Item key="3">报备数据</Menu.Item>*!/*/}
                            {/*    /!*<Menu.Item key="4">信息确认</Menu.Item>*!/*/}
                            {/*    /!*<Menu.Item key="5">批量确认</Menu.Item>*!/*/}
                            {/*</SubMenu>*/}
                            <SubMenu key="sbcl" icon={<NotificationOutlined/>} title="申报管理">
                                <Menu.Item key="/sbcl">申报材料</Menu.Item>
                                {/*<Menu.Item key="/sbnr">申报内容</Menu.Item>*/}
                                {/*<Menu.Item key="/yfhd">研发活动</Menu.Item>*/}
                                {/*<Menu.Item key="/gxcp">高新技术</Menu.Item>*/}
                                {/*<Menu.Item key="/zccqhz">知识产权</Menu.Item>*/}
                                {/*<Menu.Item key="/kffymx">开发明细</Menu.Item>*/}
                                {/*<Menu.Item key="/hyzdmx">行业标准制定明细</Menu.Item>*/}
                                {/*<Menu.Item key="/rlzy">人力资源</Menu.Item>*/}
                            </SubMenu>
                            {/*<SubMenu key="yhgl" icon={<LaptopOutlined/>} title="用户管理">*/}
                            {/*    <Menu.Item key="/Home/UserManger/AddUser">添加用户</Menu.Item>*/}
                            {/*    <Menu.Item key="/Home/UserManger/UserManger">用户管理</Menu.Item>*/}
                            {/*    <Menu.Item key="/Home/UserManger/ImportUser">导入用户</Menu.Item>*/}
                            {/*</SubMenu>*/}
                            {/*<SubMenu key="xtgl" icon={<NotificationOutlined/>} title="系统管理">*/}
                            {/*    <Menu.Item key="9">导出数据</Menu.Item>*/}
                            {/*    <Menu.Item key="10">option10</Menu.Item>*/}
                            {/*    <Menu.Item key="11">option11</Menu.Item>*/}
                            {/*    <Menu.Item key="12">option12</Menu.Item>*/}
                            {/*</SubMenu>*/}
                            {/*<SubMenu key="grzx" icon={<LaptopOutlined/>} title="个人中心">*/}
                            {/*    <Menu.Item key="5">修改密码</Menu.Item>*/}
                            {/*</SubMenu>*/}
                        </Menu>
                    </Sider>
                    <Layout style={{padding: '0 24px 24px'}}>
                        <Breadcrumb style={{margin: '16px 0'}}>
                            {historyLength > 1 && <div style={{paddingRight: '10px'}} onClick={() => {
                                window.history.back()
                            }}><ArrowLeftOutlined/> 后退
                            </div>}
                            <div style={{}}>
                                欢迎使用高企认定系统！
                            </div>
                        </Breadcrumb>
                        <Content
                            className="site-layout-background"
                            style={{
                                padding: 24, margin: 0, minHeight: 280, height: '100%', backgroundColor: '#fff'
                            }}
                        >
                            <RouterProvider router={router(logto)}/>
                        </Content>
                    </Layout>
                </Layout>
            </Layout>
        </ApolloProvider>
    )
}
